import React, { useEffect, useState } from "react";
import {
    Box, Typography, Chip, Button, IconButton, Grid, Menu, MenuItem, Card,
} from "@mui/material";
import TableComponent from "components/grid/CustomTablePMgtSummary";
import { ReactComponent as EditIcon } from "assets/icons/EditIcon.svg";
import { useParams } from "react-router-dom";
import moment from "moment";
import { LuEye, LuRefreshCw } from "react-icons/lu";
import { DEFAULT_DATE_FORMAT } from "config";
import CustomPagination from "components/CustomPagination";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const headerGroups = [
    { label: "", colSpan: 1 },
    { label: "Cost (In Inr Crs.)", colSpan: 3 },
    { label: "Reason For Variation", colSpan: 3 },
    { label: "Remarks", colSpan: 2 },
    { label: "", colSpan: 1 },
];

const tableData = [
    {
        description: "Total",
        originalBudget: "288.16",
        revisedBudget: "328.80",
        budgetVariance: "40.64",
        designChange: "27.52",
        incorrectEstimationRates: "2.13",
        incorrectEstimationMissed: "3.05",
        remarksRO: "",
        remarksR1: "",
        timeLine: "",
    },
    {
        description: "Land Development",
        originalBudget: "22.39",
        revisedBudget: "13.32",
        budgetVariance: "-9.07",
        designChange: "-9.07",
        incorrectEstimationRates: "",
        incorrectEstimationMissed: "",
        remarksRO: "GSB/Filter Media layer considered",
        remarksR1: "A -Filter layer replaced with murrum + Overall filling/cutting qty optimized Value Engg.: (-)9.07 Cr.",
        timeLine: "10.07.2025",
    },
    {
        description: "Hotel",
        originalBudget: "77.78",
        revisedBudget: "77.78",
        budgetVariance: "",
        designChange: "",
        incorrectEstimationRates: "",
        incorrectEstimationMissed: "",
        remarksRO: "",
        remarksR1: "Estimate is same as per R0",
        timeLine: "",
    },
    {
        description: "Gate & Security Cabin - 11 Nos.",
        originalBudget: "1.09",
        revisedBudget: "0.77",
        budgetVariance: "-0.32",
        designChange: "",
        incorrectEstimationRates: "-0.32",
        incorrectEstimationMissed: "",
        remarksRO: "",
        remarksR1: "B - Rate Change, considered 11 unit of cabin+gate @ 0.04 Cr. + B/barrier: 0.03 Cr. per unit",
        timeLine: "",
    },
    {
        description: "Boundary Wall Between WH-1 & Commercial Area",
        originalBudget: "",
        revisedBudget: "0.55",
        budgetVariance: "0.55",
        designChange: "",
        incorrectEstimationRates: "",
        incorrectEstimationMissed: "0.55",
        remarksRO: "",
        remarksR1: "C - Additional scope than R0",
        timeLine: "Dwg submission vide GRIP ltr.0205 dtd 14.08.2025",
    },
    {
        description: "D-Type Boundary Wall Entry",
        originalBudget: "",
        revisedBudget: "0.31",
        budgetVariance: "0.31",
        designChange: "",
        incorrectEstimationRates: "",
        incorrectEstimationMissed: "0.31",
        remarksRO: "",
        remarksR1: "C - Additional scope than R0",
        timeLine: "Dwg submission vide GRIP ltr.0205 dtd 14.08.2025",
    },
    {
        description: "Truck Parking (Incl. Fencing F Type)",
        originalBudget: "3.21",
        revisedBudget: "4.97",
        budgetVariance: "1.76",
        designChange: "1.88",
        incorrectEstimationRates: "-0.13",
        incorrectEstimationMissed: "",
        remarksRO: "Crust Details -WMM: 200 mm + GSB: 150 mm + Paver: 80 mm M50",
        remarksR1: "Crust Details - GSB: 200 mm + DLC: 180 mm + Paver: 100 mm M55 A - (+) 2.52 Cr. due to DLC, (-) 0.70 Cr. from GSB/WMM filing, (+) 0.067 OI B -  (-) 0.13 Cr. from B/wall",
        timeLine: "10.07.2025",
    },
    {
        description: "Driver Rest Room",
        originalBudget: "0.21",
        revisedBudget: "0.25",
        budgetVariance: "0.04",
        designChange: "0.04",
        incorrectEstimationRates: "",
        incorrectEstimationMissed: "",
        remarksRO: "No services considered",
        remarksR1: "A - LS 0.02 Cr. Services + 0.02 Cr. Qty variation in building",
        timeLine: "",
    },
    {
        description: "MEP",
        originalBudget: "37.33",
        revisedBudget: "45.87",
        budgetVariance: "8.54",
        designChange: "",
        incorrectEstimationRates: "8.54",
        incorrectEstimationMissed: "",
        remarksRO: "LS Estimate Considered",
        remarksR1: "B - New Scheme As Per MP Electricity Board/DISCOM",
        timeLine: "Nov-25",
    },
    {
        description: "WH-1",
        originalBudget: "45.46",
        revisedBudget: "43.69",
        budgetVariance: "-1.77",
        designChange: "3.08",
        incorrectQtyOrRates: "-5.07",
        incorrectScopeMissed: "0.22",
        remarksRO: "",
        remarksR1: "A - (+) 3.17 Cr. for earth work,  (-) 0.09 Cr. for GSB/WMM B -  (-) 1.41 Cr. for RCC,  (-) 1.11 Cr. for steel work (excl. PEB), (-) 1.51 Cr. Floor,  (-) 1.31 for services (-) 0.27 Cr. For variation in other/rest items. C - (+) 0.22 Cr. Pre-cast wall",
        timeLine: "Design submitted vide GRIP ltr. No. 213 dtd 25.08.2025",
    },
    {
        description: "BWH + ICD",
        originalBudget: "16.77",
        revisedBudget: "27.15",
        budgetVariance: "10.38",
        designChange: "9.08",
        incorrectQtyOrRates: "0.63",
        incorrectScopeMissed: "0.67",
        remarksRO: "BWH - Crust Details: WMM: 300mm + GSB 200 + Paver 80 mm M50 ICD - Crust Details: WMM: 350 mm + GSB: 350 mm + Paver: 100 mm M55 (4.5Cr.)",
        remarksR1: "BWH - Crust Details: GSB: 200 mm + DLC: 490 mm + Paver 100 mm M55 A - 2.72 Cr. for DLC, (+) + addl. 0.16 Cr. due to introducing of pre-cast wall instead of brick wall. B - (+) 0.77Cr. Against qty variation/s in sub/super structure due to design. C -  (+) 0.28Cr. for  rolling shutter (6408/Sqm > 14160/Sqm), (+) 0.39 Cr. for addl. dock leveler. ICD - Crust Details: GSB: 200 mm + DLC: 490 mm + Paver: 100 mm M55 (10.7 Cr.) A - (+) 6.2 Cr.  From DLC B -  (-) 0.14 Cr. due to Qty variation",
        timeLine: "BWH - Design submitted vide GRIP ltr. No. 214 dtd 25.08.2025 + Geo-tech & hydrology report. ICD - 10.07.2025",
    },
    {
        description: "DCT",
        originalBudget: "3.48",
        revisedBudget: "6.96",
        budgetVariance: "3.48",
        designChange: "1.78",
        incorrectQtyOrRates: "0.31",
        incorrectScopeMissed: "1.39",
        remarksRO: "Crust Details: WMM: 300 mm + GSB: 300 mm + Paver: 100 mm M55.",
        remarksR1: "Crust Details: GSB: 200 mm + DLC: 490 mm + Paver: 100 mm M55 A - (+) 1.78 Cr. from DLC B - (+) 0.31 Cr. Qty variation/s. C - (+) 1.39 from addl. building of office, storage area, toilet, & PEB for maintenance covered area.",
        timeLine: "10.07.2025",
    },
    {
        description: "Road",
        originalBudget: "25.50",
        revisedBudget: "27.45",
        budgetVariance: "1.95",
        designChange: "1.49",
        incorrectQtyOrRates: "-1.08",
        incorrectScopeMissed: "1.54",
        remarksRO: "Crust Details: WMM: 350 mm + GSB: 350 mm + PQC: 250 mm (main) + Paver: 60mm M40 (service)",
        remarksR1: "Crust Details: GSB: 200 mm + DLC: 150 – 180 mm + PQC: 260 mm (Excl. yard) + Paver: 100 mm M55 (yard) +  12788Sqm road of PH-1 considered upto sub-grade level only. A - (+) 0.96 Cr Addl. item of geo-textile , (+) Extra groove: 0.53 Cr. B - (-) 1.3 Cr. saving from WMM+GSB section,  (+) 0.22 Cr. Qty variation/s. C -  (+) 1.3 Cr. Saucer drain  (+) 0.24 Cr signage.",
        timeLine: "Design submitted vide GRIP  Ltr. No. 198 dtd 29.07.2025",
    },
    {
        description: "Platform",
        originalBudget: "19.95",
        revisedBudget: "26.77",
        budgetVariance: "6.82",
        designChange: "4.59",
        incorrectQtyOrRates: "1.83",
        incorrectScopeMissed: "0.40",
        remarksRO: "Crust Details: WMM: 350 mm + GSB: 300 mm + Paver: 80 mm M50 + COP Part By Part",
        remarksR1: "Crust Details: GSB: 200 mm + DLC: 180 mm (PF 2-6) + DLC: 430 mm (PF-1/ICD) + Paver: 100 mm M55 + PF-5 considered upto sub-grade level only + continues COP . A -  (+) 4.59 due to PF Crust Changes (180 mm Increase) B - (+) 1.83 Cr. COP C -  (+) 0.40 Cr. Services",
        timeLine: "10.07.2025",
    },
    {
        description: "Admin",
        originalBudget: "6.90",
        revisedBudget: "7.81",
        budgetVariance: "0.91",
        designChange: "",
        incorrectQtyOrRates: "0.76",
        incorrectScopeMissed: "0.15",
        remarksRO: "",
        remarksR1: " Boundary wall for admin-campus B - (+) 0.76 Cr. due to qty variation (major impact due to soil improvement) C - (+) 0.15 Cr. B/wall  ",
        timeLine: " Dwg submission vide GRIP ltr.0205 dtd 14.08.2025 ",
    },
    {
        description: "B/Wall (Entire North Side, West Side & Truck Parking Area)",
        originalBudget: "7.61",
        revisedBudget: "5.86",
        budgetVariance: "-1.75",
        designChange: "-1.75",
        incorrectQtyOrRates: "",
        incorrectScopeMissed: "",
        remarksRO: "",
        remarksR1: "A -  (-) 1.75 Boundary wall along the railway track considered in nala cum boundary wall",
        timeLine: "Dwg submission vide GRIP ltr.0207 dtd 16.08.2025",
    },
    {
        description: "Nala",
        originalBudget: "1.09",
        revisedBudget: "17.32",
        budgetVariance: "16.23",
        designChange: "16.23",
        incorrectQtyOrRates: "",
        incorrectScopeMissed: "",
        remarksRO: "Boulder Pitching On Nala",
        remarksR1: "RCC nala designed according to hydrology data & constraint of avl. land along the railway track A - (+) 15.29 Cr. RCC works,  (+) 0.94 Cr. Earth work ",
        timeLine: " Dwg submission vide GRIP ltr.0207 dtd 16.08.2025 ",
    },
    {
        description: "Fuel Station (Boundary Wall + Additional Works)",
        originalBudget: "1.13",
        revisedBudget: "1.30",
        budgetVariance: "0.17",
        designChange: "0.17",
        incorrectQtyOrRates: "",
        incorrectScopeMissed: "",
        remarksRO: "Estimated for complete paved floor",
        remarksR1: "Considered Paved Floor + Boundary Wall + Office Building. A - (+) 0.17 Cr ",
        timeLine: "",
    },
    {
        description: "Landscaping",
        originalBudget: "5.02",
        revisedBudget: "2.08",
        budgetVariance: "-2.94",
        designChange: "",
        incorrectQtyOrRates: "-2.94",
        incorrectScopeMissed: "",
        remarksRO: "",
        remarksR1: " Qty optimized B - (-)  2.57 Cr.Hardscape, (-) 0.01 Cr.Soft scape, (-) 0.36 Cr.irrigation ",
        timeLine: "",
    },
    {
        description: "Civil Works_Other Foundation Works",
        originalBudget: "2.25",
        revisedBudget: "2.25",
        budgetVariance: "0.00",
        designChange: "",
        incorrectQtyOrRates: "",
        incorrectScopeMissed: "0.00",
        remarksRO: "LS Basis",
        remarksR1: "Foundation for equipment (electrical, fire plant, high mast + street light + water tank + STP)",
        timeLine: "",
    },
    {
        description: "Canteen",
        originalBudget: "2.17",
        revisedBudget: "",
        budgetVariance: "-2.17",
        designChange: "",
        incorrectQtyOrRates: "",
        incorrectScopeMissed: "-2.17",
        remarksRO: "",
        remarksR1: "Deferment from Phase-1",
        timeLine: "",
    },
    {
        description: "Weigh Bridge",
        originalBudget: "1.33",
        revisedBudget: "0.91",
        budgetVariance: "-0.42",
        designChange: "",
        incorrectQtyOrRates: "-0.42",
        incorrectScopeMissed: "",
        remarksRO: "",
        remarksR1: " Material Procured. B - (-) 0.42 on Savings on Procurement ",
        timeLine: "",
    },
    {
        description: "EPC Design Cost",
        originalBudget: "7.50",
        revisedBudget: "7.50",
        budgetVariance: "",
        designChange: "",
        incorrectQtyOrRates: "",
        incorrectScopeMissed: "",
        remarksRO: "",
        remarksR1: "Estimate is same as per R0",
        timeLine: "",
    },
    {
        description: "Electrical Items Procured Not Required As New Electrical Scheme. (Transformer,Panel HT)",
        originalBudget: "",
        revisedBudget: "1.72",
        budgetVariance: "",
        designChange: "",
        incorrectQtyOrRates: "",
        incorrectScopeMissed: "",
        remarksRO: "",
        remarksR1: "",
        timeLine: "",
    },
    {
        description: "Deferement From Phase-I",
        originalBudget: "",
        revisedBudget: "6.21",
        budgetVariance: "",
        designChange: "",
        incorrectQtyOrRates: "",
        incorrectScopeMissed: "",
        remarksRO: "",
        remarksR1: "",
        timeLine: "",
    },
    {
        description: "Canteen Building",
        originalBudget: "",
        revisedBudget: "2.17",
        budgetVariance: "",
        designChange: "",
        incorrectQtyOrRates: "",
        incorrectScopeMissed: "",
        remarksRO: "",
        remarksR1: "",
        timeLine: "",
    },
    {
        description: "Platform No-4",
        originalBudget: "",
        revisedBudget: "2.42",
        budgetVariance: "",
        designChange: "",
        incorrectQtyOrRates: "",
        incorrectScopeMissed: "",
        remarksRO: "",
        remarksR1: "",
        timeLine: "",
    },
    {
        description: "Road Works",
        originalBudget: "",
        revisedBudget: "1.62",
        budgetVariance: "",
        designChange: "",
        incorrectQtyOrRates: "",
        incorrectScopeMissed: "",
        remarksRO: "",
        remarksR1: "",
        timeLine: "",
    },
    {
        description: "Capex Catch Up Plan - Due To Value Engg",
        originalBudget: "",
        revisedBudget: "13.21",
        budgetVariance: "",
        designChange: "",
        incorrectQtyOrRates: "",
        incorrectScopeMissed: "",
        remarksRO: "",
        remarksR1: "",
        timeLine: "",
    },
    {
        description: "FM2 Flooring",
        originalBudget: "",
        revisedBudget: "1.51",
        budgetVariance: "",
        designChange: "",
        incorrectQtyOrRates: "",
        incorrectScopeMissed: "",
        remarksRO: "",
        remarksR1: "",
        timeLine: "",
    },
    {
        description: "DLC Material Supply + Laying (Outside Supply)",
        originalBudget: "",
        revisedBudget: "8.60",
        budgetVariance: "",
        designChange: "",
        incorrectQtyOrRates: "",
        incorrectScopeMissed: "",
        remarksRO: "",
        remarksR1: "",
        timeLine: "",
    },
    {
        description: "Paver Block (Outside Supply)",
        originalBudget: "",
        revisedBudget: "1.11",
        budgetVariance: "",
        designChange: "",
        incorrectQtyOrRates: "",
        incorrectScopeMissed: "",
        remarksRO: "",
        remarksR1: "",
        timeLine: "",
    },
    {
        description: "ICD -Section Optimization",
        originalBudget: "",
        revisedBudget: "1.99",
        budgetVariance: "",
        designChange: "",
        incorrectQtyOrRates: "",
        incorrectScopeMissed: "",
        remarksRO: "",
        remarksR1: "",
        timeLine: "",
    },
]

const ProjectMgtSummary = () => {
    const { projectId } = useParams();
    const boldRowIndexes = [0, 23, 24, 28];
    // sorting asc desc
    const [sortOrder, setSortOrder] = React.useState('desc');
    const [sortBy, setSortBy] = React.useState('createdDate');

    // page size
    const [pageNumber, setPageNumber] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(10);
    const [loading, setLoading] = useState(false);

    const [filters, setFilters] = useState({
        ProjectId: projectId,
        SortBy: sortBy,
        SortOrder: sortOrder,
        PageNumber: pageNumber,
        PageSize: pageSize,
    });

    const handlePageChange = (newPage) => {
        setPageNumber(newPage);
        const updatedFilters = {
            ...filters,
            PageNumber: newPage,
        };
        setFilters(updatedFilters);
        // trigger(updatedFilters);
    };

    const handlePageSizeChange = (newSize) => {
        setPageSize(newSize);
        setPageNumber(1);
        const updatedFilters = {
            ...filters,
            PageSize: newSize,
            PageNumber: 1,
        };
        setFilters(updatedFilters);
        // trigger(updatedFilters);
    };

    useEffect(() => {
        // trigger(filters);
    }, []);

    const handleRequestSort = (property) => {
        const isAsc = sortBy === property && sortOrder === 'asc';
        const updatedFilters = {
            ...filters,
            SortBy: property,
            SortOrder: isAsc ? 'desc' : 'asc'

        };
        setFilters(updatedFilters);
        setSortOrder(isAsc ? 'desc' : 'asc');
        setSortBy(property);
        // trigger(updatedFilters);

    };

    const columns = [
        {
            name: "Description",
            field: "description",
            width: "200px",
            renderer: (row) => (
                <>
                    {row?.description ? row?.description : '-'}
                </>
            ),
        },
        {
            name: "Original R0 Budget",
            field: "originalBudget",
            width: "80px",
            renderer: (row) => (
                <>
                    {row?.originalBudget ? row?.originalBudget : '-'}
                </>
            ),
        },
        {
            name: "(R1) Revised Budget",
            field: "revisedBudget",
            width: "80px",
            renderer: (row) => (
                <>
                    {row?.revisedBudget ? row?.revisedBudget : '-'}
                </>
            ),
        },
        {
            name: "Budget Variance",
            field: "budgetVariance",
            width: "80px",
            renderer: (row) => (
                <>
                    {row?.budgetVariance ? row?.budgetVariance : '-'}
                </>
            ),
        },
        {
            name: "Design / Spec Change",
            field: "designChange",
            width: "80px",
            renderer: (row) => (
                <>
                    {row?.designChange ? row?.designChange : '-'}
                </>
            ),
        },
        {
            name: "Incorrect Estimation (Quantity Or Rates)",
            field: "incorrectEstimationRates",
            width: "80px",
            renderer: (row) => (
                <>
                    {row?.incorrectEstimationRates ? row?.incorrectEstimationRates : '-'}
                </>
            ),
        },
        {
            name: "Incorrect Estimation (Scope Items Missed)",
            field: "incorrectEstimationMissed",
            width: "80px",
            renderer: (row) => (
                <>
                    {row?.incorrectEstimationMissed ? row?.incorrectEstimationMissed : '-'}
                </>
            ),
        },
        {
            name: "RO",
            field: "remarksRO",
            width: "120px",
            renderer: (row) => (
                <>
                    {row?.remarksRO ? row?.remarksRO : '-'}
                </>
            ),
        },
        {
            name: "R1",
            field: "remarksR1",
            width: "230px",
            renderer: (row) => (
                <>
                    {row?.remarksR1 ? row?.remarksR1 : '-'}
                </>
            ),
        },
        {
            name: "Tentative Triggered Timeline",
            field: "timeLine",
            width: "80px",
            renderer: (row) => (
                <>
                    {row?.timeLine ? row?.timeLine : '-'}
                </>
            ),
        },
    ];

    // return (
    //     <Card elevation={0} sx={{ borderRadius: 3, border: "1px solid #E4E4E4" }}>
    //         <Box sx={{ p: 1.5, borderBottom: "1px solid #E4E4E4" }}>
    //             <Typography sx={{ fontWeight: 600, fontSize: "20px", fontFamily: "Outfit" }}>
    //                 Project Management Summary - Phase 1 Project Budget Sheet
    //             </Typography>
    //             <Typography sx={{ fontWeight: 300, fontSize: "16px", color: "#7D7F81" }}>

    //             </Typography>
    //         </Box>

    //         <Grid container>
    //             <Grid size={{ md: 12 }}>

    //                 <TableComponent
    //                     columns={columns}
    //                     headerGroups={headerGroups}
    //                     data={tableData}
    //                     boldRowIndexes={boldRowIndexes}
    //                     stickyRowIndexes={[0]}
    //                 // createSortHandler={handleRequestSort}
    //                 // loading={loading}
    //                 // order={sortOrder}
    //                 // orderBy={sortBy}
    //                 />

    //                 {/* <CustomPagination
    //                     totalCount={tableData.length}
    //                     pageSize={pageSize}
    //                     page={pageNumber}
    //                     onPageChange={handlePageChange}
    //                     setCurrentPage={setPageNumber}
    //                     onPageSizeChange={handlePageSizeChange}
    //                 /> */}
    //             </Grid>
    //         </Grid>
    //     </Card>
    // );
};

export default ProjectMgtSummary;
